var _style, _path, _path2, _path3, _defs, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationMagnifyingglassMoney = function SvgSimpleIllustrationMagnifyingglassMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__magnifyingglass-money_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__magnifyingglass-money_svg__st2{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M39.538 43.181h15.784s2.256-.424 2.256-3.963V13.566l-2.985 2.561-2.376-2.925-2.376 2.925-2.681-2.741-2.74 2.865-2.256-2.865-2.256 2.805-2.681-2.376v11.756l2.316 17.61h-.005z",
    style: {
      fill: "#fffaf0",
      stroke: "#002140",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.962 23.01H35.469v38.022h23.493V23.01z",
    style: {
      fill: "#5be3aa",
      stroke: "#002140",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__magnifyingglass-money_svg__st2",
    d: "M58.962 61.032s.388-2.694-2.861-2.694h-18.16c-2.395 0-2.473 2.694-2.473 2.694M47.215 23.01v35.258"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.582 42.516c10.248 0 18.556-8.308 18.556-18.556 0-10.248-8.308-18.556-18.556-18.556S15.026 13.712 15.026 23.96c0 10.248 8.308 18.556 18.556 18.556z",
    style: {
      fill: "#ffed8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.853 39.046c8.316 0 15.057-6.741 15.057-15.057S42.168 8.932 33.853 8.932c-8.316 0-15.057 6.741-15.057 15.057s6.741 15.057 15.057 15.057z",
    style: {
      fill: "#99f6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.68 40.33-6.085-5.355-12.82 12.657s-.811 3 .73 4.867 5.014.961 5.275.569c.26-.392 12.9-12.738 12.9-12.738z",
    style: {
      fill: "#d18000"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__magnifyingglass-money_svg__st2",
    d: "M33.523 42.358c10.127 0 18.336-8.209 18.336-18.336S43.65 5.686 33.523 5.686c-10.127 0-18.336 8.209-18.336 18.336s8.21 18.336 18.336 18.336z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__magnifyingglass-money_svg__st2",
    d: "M18.478 34.996 6.418 47.053a3.977 3.977 0 0 0 0 5.623 3.977 3.977 0 0 0 5.623 0l12.423-12.423"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "simple-illustration__magnifyingglass-money_svg__SVGID_1_",
    d: "M33.629 9.458c8.126 0 14.713 6.587 14.713 14.713s-6.587 14.713-14.713 14.713-14.713-6.587-14.713-14.713S25.503 9.458 33.629 9.458z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "simple-illustration__magnifyingglass-money_svg__SVGID_00000026851416195346436300000010833639386532402350_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#simple-illustration__magnifyingglass-money_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#simple-illustration__magnifyingglass-money_svg__SVGID_00000026851416195346436300000010833639386532402350_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.501 47.935h19.757s2.824-.531 2.824-4.961v-32.11l-3.736 3.205-2.974-3.661-2.974 3.661-3.355-3.431-3.431 3.586-2.824-3.586-2.824 3.511-3.355-2.974V25.89l2.899 22.044h-.007z",
    style: {
      fill: "#e5fafe",
      stroke: "#002140",
      strokeWidth: 1.0509,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.814 22.685H28.407v47.593h29.407V22.685z",
    style: {
      fill: "#ccf6ff",
      stroke: "#002140",
      strokeWidth: 1.0509,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.11 22.685v44.134",
    style: {
      fill: "none",
      stroke: "#002140",
      strokeWidth: 1.0509,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__magnifyingglass-money_svg__st2",
    d: "M33.629 38.884c8.126 0 14.713-6.587 14.713-14.713S41.754 9.458 33.629 9.458s-14.713 6.587-14.713 14.713 6.587 14.713 14.713 14.713z"
  })));
};
export default SvgSimpleIllustrationMagnifyingglassMoney;